import axios from "axios";
import { apiUrl } from "../constant";

const fetchAllCompanyDetailsService = (data) => {
    return axios.post(`${apiUrl}/GetAllCompany`, data);
};

export const ratecardService = {
    fetchAllCompanyDetailsService
}